// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .container_4_machine {
}
.machine_container {
  background-color: red;
  width: 50%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  height: 40vh;
}
.slide_vending_container {
  grid-column-start: 0;
  grid-row-start: 0;
  background-color: blanchedalmond;

}
.machine_info_box {
  grid-column-start: 0;
  grid-row-start: 0;
  background-color: rgb(60, 255, 0);

}
.slide_vending {
  border-bottom: 2px solid;
  background-color: black;
  height: 100%;
}
.slide_content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vendingmachine {
  background-color: rgb(196, 0, 0);
  border: 1px solid;
  width: 5vw;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
 */

.box_machine {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.card_machine {
  background-color: var(--ColorSecondaryDark);
  width: 15vw;
  height: 50vh;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 30px;
  box-shadow: inset -13px -6px 35px -22px rgba(0, 0, 0, 0.75);
}
.glass {
  background-color: var(--ColorShadow);
  border: 2px solid;
  border-radius: 20px;
  height: 90%;
  width: auto;
  padding: 10px;
  text-align: justify;
  overflow-y: scroll;
}
.glass text {
  margin: 10px;
}
.button_machine {
  width: auto;
}
.button_machine button {
  margin-top: 1rem;
  border: none;
  border-radius: 20px;
  width: 95%;
  height: 3rem;
  background-color: var(--ColorThirdDark);
  color: var(--ColorSecondaryDark);
  font-weight: 900;
}
.products_box {
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
}
.product {
  background-color: var(--ColorThirdDark);
  padding: 2rem;
  margin: 1rem;
  border-radius: 20px;
  box-shadow: 29px 30px 62px -35px rgba(0, 0, 0, 0.75);
}
.product_picture {
  background-color: aqua;
  width: 5vw;
  height: 5vw;
  border-radius: 100%;
}

.cam {
  width: 10vw;
  height: 15vh;
  margin-right: 4vw;
}
.freezer {
  background-color: var(--ColorPrimary);
  box-shadow: -6px 6px 5px 0px lightgray;
  width: 90vw;
  border-radius: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: 5vh;
  align-items: center;
  padding-top: 3vh;
  padding-bottom: 3vh;
}
.container_machine {
  margin: 2rem;
  width: 90vw;

  align-self: center;
}

.container_images {
  display: flex;

  justify-content: space-evenly;
}
`, "",{"version":3,"sources":["webpack://./src/pages/VendingMachine/VendingMachine.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuCE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,2DAA2D;AAC7D;AACA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;;EAEX,kBAAkB;AACpB;;AAEA;EACE,aAAa;;EAEb,6BAA6B;AAC/B","sourcesContent":["/* .container_4_machine {\n}\n.machine_container {\n  background-color: red;\n  width: 50%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr;\n  height: 40vh;\n}\n.slide_vending_container {\n  grid-column-start: 0;\n  grid-row-start: 0;\n  background-color: blanchedalmond;\n\n}\n.machine_info_box {\n  grid-column-start: 0;\n  grid-row-start: 0;\n  background-color: rgb(60, 255, 0);\n\n}\n.slide_vending {\n  border-bottom: 2px solid;\n  background-color: black;\n  height: 100%;\n}\n.slide_content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.vendingmachine {\n  background-color: rgb(196, 0, 0);\n  border: 1px solid;\n  width: 5vw;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n */\n\n.box_machine {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n.card_machine {\n  background-color: var(--ColorSecondaryDark);\n  width: 15vw;\n  height: 50vh;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  padding: 30px;\n  box-shadow: inset -13px -6px 35px -22px rgba(0, 0, 0, 0.75);\n}\n.glass {\n  background-color: var(--ColorShadow);\n  border: 2px solid;\n  border-radius: 20px;\n  height: 90%;\n  width: auto;\n  padding: 10px;\n  text-align: justify;\n  overflow-y: scroll;\n}\n.glass text {\n  margin: 10px;\n}\n.button_machine {\n  width: auto;\n}\n.button_machine button {\n  margin-top: 1rem;\n  border: none;\n  border-radius: 20px;\n  width: 95%;\n  height: 3rem;\n  background-color: var(--ColorThirdDark);\n  color: var(--ColorSecondaryDark);\n  font-weight: 900;\n}\n.products_box {\n  margin: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.product {\n  background-color: var(--ColorThirdDark);\n  padding: 2rem;\n  margin: 1rem;\n  border-radius: 20px;\n  box-shadow: 29px 30px 62px -35px rgba(0, 0, 0, 0.75);\n}\n.product_picture {\n  background-color: aqua;\n  width: 5vw;\n  height: 5vw;\n  border-radius: 100%;\n}\n\n.cam {\n  width: 10vw;\n  height: 15vh;\n  margin-right: 4vw;\n}\n.freezer {\n  background-color: var(--ColorPrimary);\n  box-shadow: -6px 6px 5px 0px lightgray;\n  width: 90vw;\n  border-radius: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  margin-bottom: 5vh;\n  align-items: center;\n  padding-top: 3vh;\n  padding-bottom: 3vh;\n}\n.container_machine {\n  margin: 2rem;\n  width: 90vw;\n\n  align-self: center;\n}\n\n.container_images {\n  display: flex;\n\n  justify-content: space-evenly;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
